import * as CalibrationConstants from './CalibrationConstants';
import AppService from 'Global/AppService';

const addDeviceToCalibrationReducerState = (instanceId) => {
	return {
		type: CalibrationConstants.CALIBRATION_DATA_STATE_ADD,
		payload: instanceId
	}
};

const removeDeviceToCalibrationReducerState = (instanceId) => {
	return {
		type: CalibrationConstants.CALIBRATION_DATA_STATE_REMOVE,
		payload: instanceId
	}
};


const getCalibData = (url,payload,deviceId) => {
	
	return (dispatch) => {
		dispatch({ type: CalibrationConstants.CALIBRATION_DATA_FETCHING,payload:deviceId });

		function callback(success, err) {
			
			if (success && success.result) {
				dispatch(getCalibDataSuccess(success,deviceId));
                } else {
				dispatch(getCalibDataFailure(deviceId));
			}
		}

		AppService.postData(payload, url, callback);
	}
}

const getCalibDataSuccess = (successResponse,deviceId) => {
	return { type: CalibrationConstants.CALIBRATION_DATA_FETCHED, payload:{newState: successResponse,deviceId:deviceId} };
}

const getCalibDataFailure = (deviceId) => {
	return { type: CalibrationConstants.CALIBRATION_DATA_FETCHING_FAILED,payload:deviceId };
}

const getCalReportConfig = (url,deviceId) => {
	
	return (dispatch) => {
		dispatch({ type: CalibrationConstants.CALIBRATION_CONFIG_FETCHING,payload:deviceId });

		function callback(success, err) {
			
			if (success && success.result) {
				dispatch(getCalReportConfigSuccess(success,deviceId));
                } else {
				dispatch(getCalReportConfigFailure(deviceId));
			}
		}

		AppService.getData(url, callback);
	}
}

const getCalReportConfigSuccess = (successResponse,deviceId) => {
	return { type: CalibrationConstants.CALIBRATION_CONFIG_FETCHED, payload:{newState: successResponse,deviceId:deviceId} };
}

const getCalReportConfigFailure = (deviceId) => {
	return { type: CalibrationConstants.CALIBRATION_CONFIG_FAILED,payload:deviceId };
}


export {
	addDeviceToCalibrationReducerState,
	removeDeviceToCalibrationReducerState,
    getCalibData,
	getCalibDataSuccess,
	getCalibDataFailure,
	getCalReportConfig
}